// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__YygRQ","info":"Note_info__2SONk","note":"Note_note__3dhvB","actions":"Note_actions__1s0N-"};